import styled from 'styled-components';
import zIndexShade from '../../utils/zIndexScale';

const Shade = styled.div`
  background-color: ${({ theme }) => theme.loadingShadeColor};
  bottom: 0;
  height: 100%;
  left: 0;
  opacity: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  transition: opacity .3s ease-in-out;
  width: 100%;
  z-index: ${zIndexShade.shade};
  ${({ hidden }) => !hidden ? `
    pointer-events: auto;
    opacity: 1;
  ` : ''}
`;

export default Shade;
